
import Vue from 'vue';
import type VueI18n from 'vue-i18n';
import { Component, Prop } from 'vue-property-decorator';

import { avgRGBFromBlurHash } from '@/helpers/base83-helper';
import { StreamInfo, CompetitionContent } from './types';

import PictureComp from '@/components/picture/PictureComp.vue';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

@Component({
	name: 'ProviderStreamsComparatorBar',
	components: { PictureComp },
})
export default class ProviderStreamsComparatorBar extends Vue {
	faChevronDown = faChevronDown;

	@Prop({ required: true }) streamInfo: StreamInfo | undefined;
	@Prop({ required: true }) eventTranslation: (count: number) => VueI18n.TranslateResult;

	showMoreCompetitions = false;

	get competitions() {
		return [...Object.values(this.streamInfo?.competitions ?? {})].sort((a, b) => b.count - a.count);
	}

	get extraCompetitions() {
		if (this.competitions.length > 3) return this.competitions.length - 3;
		return false;
	}

	competitionStyles({ count, iconBlurHash }: CompetitionContent, total: number, index: number) {
		const [R, G, B] = iconBlurHash
			? avgRGBFromBlurHash(iconBlurHash)
			: // color gradient for cases with multiple fallbacks
			  [255, 255, 255].map(v => (v -= 22 * index));

		return {
			backgroundColor: `rgb(${R}, ${G}, ${B})`,
			flexGrow: Math.round((count / total) * 100),
		};
	}

	imageUrl(url: string) {
		return Vue.filter('Thumbor')({ url, imageType: 'competitor_icon' });
	}
}
